.divider {
  border: none;
  margin: 0;
}

.horizontal {
  composes: divider;
  border-block-start: 1px solid var(--md-outline-variant);
  width: 100%;
}

.vertical {
  composes: divider;
  border-inline-start: 1px solid var(--md-outline-variant);
  align-self: stretch;
}
